import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Dictionary } from '@ngrx/entity';

import * as fromActions from '@app/root-store/dictionaries/functions-flat/functions-flat.actions';
import { TaxonomyFlat } from '@app/types';

export interface State extends EntityState<TaxonomyFlat> {}

export const adapter: EntityAdapter<TaxonomyFlat> =
  createEntityAdapter<TaxonomyFlat>({
    selectId: entity => entity.id
});

export const initialState: State = {
  ...adapter.getInitialState(),
};

const functionsFlatReducer = createReducer(
  initialState,
  on(fromActions.functionsFlatCollectionAddMany, (state, {functionsFlat}) => (
    adapter.addMany(functionsFlat, state)
  )),
);

export function reducer(state: State | undefined, action: Action) {
  return functionsFlatReducer(state, action);
}

export const getIds = adapter.getSelectors().selectIds;
export const getEntities = adapter.getSelectors().selectEntities;
export const getAll = adapter.getSelectors().selectAll;
export const getAllActive = (taxonomies: Array<TaxonomyFlat>) => {
  const activeTaxo = taxonomies.filter(t => {
    const parent = taxonomies.find(p => !!t.parentId && p.id === t.parentId);
    return (t.isActive && parent && parent.isActive) || (t.isActive && t.parentId === null);
  });
  return activeTaxo;
};

export const getTotal = adapter.getSelectors().selectTotal;

export const getEntityById = (entities: Dictionary<TaxonomyFlat>, {id}) => entities[id];
export const getEntitiesById = (entities: Dictionary<TaxonomyFlat>, {ids}) => ids.map(id => entities[id]);
export const getRootId = (taxonomies: Array<TaxonomyFlat>) => taxonomies.filter((entity) => entity.parentId === null);
